import React, { useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../styles/login.css";
import "./Login.scss";
import "./forgetPassword";
import axios from "axios";
import { loginReducer, sidebarReducer } from "../../Redux/store";
import { AccessTockenReducer } from "../../Redux/store";
import { permissionsReducer } from "../../Redux/store";
import { loginRequest } from "../../Office365/authConfig";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as CMSLOGO } from "../../images/CMS_UMS_LOGO.svg";
import ofc365 from '../../images/new_ui/Office365.png';
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import TextField from "@material-ui/core/textfield";
import { InputAdornment, IconButton } from "@mui/material";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import MainComponent from "./MainComponent";

function Userlogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { instance, accounts, inProgress } = useMsal();
  const dispatch = useDispatch();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loginFail, setLoginFail] = useState(false);
  const [notAuth, setNotAuth] = useState(false);
  // const [apiLoad, setApiLaod] = useState(false);
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);
  useEffect(() => {
    console.log("MSAL State");
  }, [accounts, inProgress, instance]);
  // Add these variables to your component to track the stateconst [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
  const handleSubmit = (e) => {
    //Main login function
    e.preventDefault();
    if (!emailPattern.test(userName)) {
      setLoginFail(true);
      setNotAuth(false);
      return;
    }
    if (userName ==="") {

      toast.warn("User name is missing", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (password ==="") {

      toast.warn("Password is missing", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (userName !=="" && password !=="") {

      login();
    }
  };
  const login = async () => {
    // e.preventDefault();
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    dispatch(AccessTockenReducer.userType("platform"));

    await axios
      .post(
        "auth/login",
        // "loginauth/userlogin",
        JSON.stringify({ te_useremail: userName, te_userpassword: password }),
        {
          headers: { "content-type": "application/json" },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          // navigate('/webpage');
          // setApiLaod(false);

          if (
            response.data.message === "User not found" ||
            response.data.message === "Incorrect Password"
          ) {
            setLoginFail(true);
            navigate("/login");
            // navigate('/webpage');
          } else if (
            response.data.message === "License not found for this USER ID"
          ) {
       
            toast.error(response.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate("/login");
            setNotAuth(true);
          } else {
            setLoginFail(false);
          console.log(response.data.data.user_details.te_role_id)
            const userRoleID = response.data.data.user_details.te_role_id;
            const accessTKN = response.data.data.user_details.access_token;
            const loginUserId = response.data.data.user_details.te_userid;
            const user_Name = response.data.data.user_details.te_username;
            const userRoleType =  response.data.data.userRoleType;
            const vrdevicecode =  response.data.data.vrdevicecode;
            const userdata = response.data.data.user_details;
            const permissions = response.data.data.permissions.modules;
            const refreshToken = response.data.data.user_details.refresh_token;
            console.log("refreshToken",refreshToken)
            dispatch(permissionsReducer.setPermissions(permissions));
            sessionStorage.setItem("permissions", JSON.stringify(permissions));
            dispatch(loginReducer.Login());
            dispatch(loginReducer.Login_UserId(loginUserId));
            dispatch(AccessTockenReducer.accessTocken(accessTKN));
            dispatch(loginReducer.Login_UserName(user_Name));
            dispatch(sidebarReducer.stringUpdate("ListUsers"));
           sessionStorage.setItem("userRoleID", userRoleID);
            sessionStorage.setItem("isLogin", true);
            sessionStorage.setItem("refreshToken",refreshToken)
    

            if (response.data.data.user_details.te_is_temp_pwd === 1) {
              sessionStorage.setItem("userdata", JSON.stringify(userdata));
              sessionStorage.setItem("access_token", accessTKN);
              navigate("/resetPassword");
            } else {
            
              sessionStorage.setItem("userdata", JSON.stringify(userdata));
              sessionStorage.setItem("access_token", accessTKN);
              navigate("/newhome-ums");
              sessionStorage.setItem("navigate", "ListUsers");
              sessionStorage.setItem("userRoleType", userRoleType);
              sessionStorage.setItem("vrdevicecode", vrdevicecode);
          

          
           if(userRoleID !== 98){
            // console.log(userRoleID)
            // window.open(
            //   `${process.env.REACT_APP_UNITY_WEBGL_URL}?accessToken=${accessTKN}`,
            //   "_blank"
            // );
           }
             
            }
          }
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        if(err.response){
         
          toast.error(err.response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        else
        {
         
          toast.error("Connect lost", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

        }
     

      });
  };

 
const handleLogin = async () => {

  try {
    const response = await instance.loginRedirect({
      scopes: ["User.Read"]
    });

    const accessToken = response.accessToken;
    localStorage.setItem('access_token', accessToken);
    sessionStorage.setItem('access_token', accessToken);
    navigate("/newhome-ums");

  } catch (error) {
    console.error("Login failed", error);
  }
};



  return (
    <div className="login-page">
      <ToastContainer />
      <AuthenticatedTemplate>
        <MainComponent />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
      <div
        className="container-fluid g-0 m-0 p-0"
        style={{ overflow: "hidden" }}
      >
        <div className="row">
          <CMSLOGO
            style={{
              width: "30px",
              height: "auto",
              position: "absolute",
              top: "40px",
              left: "60px",
            }}
          />
        </div>
        <div className="row ">
          <div className="col-lg-6 col-md-6 text-center col-sm-12 col-one">
            <div style={{ marginTop: "11%", marginLeft: "40px" }}>
              <form onSubmit={handleSubmit} className="login-form">
                <div className="welcomeback">Welcome Back</div>
                <div className="enter-details" style={{ cursor: "default" }}>
                  Please enter your details
                </div>
                {loginFail && (
                  <p className="p-0 m-0 text-danger">
                    Invalid Email ID or password
                  </p>
                )}
                {notAuth && (
                  <p className="p-0 m-0 text-danger">
                    You are not authorzied to access!
                  </p>
                )}

                <Box
                  //component="form"
                  sx={{
                    "& > :not(style)": { width: "100%" },
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <div
                    className="label-items"
                    style={{ paddingBottom: "6px", position: "relative" }}
                  >
                    Email ID
                  </div>
                  <TextField
                    id="UserName"
                    placeholder="Email ID"
                    variant="outlined"
                    InputLabelProps={{ shrink: false }}
                    maxLength={"15"}
                    value={userName}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        background: "#1A1A1A",
                        border: "1px solid #262626",
                        borderRadius: "10px",
                      },

                      "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover": {
                        "& > fieldset": {
                          borderColor: "#262626",
                          border: "1px solid",
                          borderRadius: "5px",
                        },
                      },
                    }}
                    InputProps={{
                      style: {
                        height: "47px",
                        color: "#FFFFFF",
                      },
                    }}
                    onChange={(e) => {
                      const { value } = e.target;
                      setUserName(value);
                      setLoginFail(false);
                      setNotAuth(false);
                    }}
                    // style={{ backgroundColor: "grey" }}
                  />

                  <br></br>
                  <div
                    className="label-items"
                    style={{ paddingBottom: "6px", position: "relative" }}
                  >
                    Password
                  </div>
                  <TextField
              
                    placeholder="Password"
                    variant="outlined"
                    autoComplete="off"
                    inputProps={{
                      autoComplete: 'new-password',
                    }}
                    InputLabelProps={{ shrink: false }}
                    
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        background: "#1A1A1A",
                        border: "1px solid #262626",
                        borderRadius: "10px",
                      },

                      "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover": {
                        "& > fieldset": {
                          borderColor: "#262626",
                          border: "1px solid",
                          borderRadius: "5px",
                        },
                      },
                    }}
                    minLength="8"
                    maxLength="20"
                    value={password}
                    onChange={(e) => {
                      const { value } = e.target;
                      setPassword(value);
                      setLoginFail(false);
                      setNotAuth(false);
                    }}
                    type={showPassword ? "text" : "password"} 
                   
                    InputProps={{
                      // <-- This is where the toggle button is added.
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            style={{ color: "#FFFFFF" }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                      style: {
                        height: "47px",
                        color: "#FFFFFF",
                      },
                    }}
                  />
                </Box>

                <div
                  className="forgotpassword"
                  onClick={() => {
                    navigate("/forgetPassword");
                  }}
                >
                  <button className="forgot-button" type="button">Forgot Password?</button>
                </div>
                <button className="signupbtn" type="submit">Sign In</button>
                
                <br></br>
                {/* <div>
       
                <span className="sso-button">Or Sign In with
                  </span>
                  </div> */}
                  {/* <button className="SSOsignupbtn"  
                     onClick={(e) => {
                      e.preventDefault(); // Prevent form submission
                      setLoginFail(false); // Reset login fail state
                      setNotAuth(false); // Reset not authorized state
                      handleLogin(); // Trigger Office 365 login
                    }}>
                  <img src={ofc365} className="ofc365-icon" alt="ofc365" />
                  Office 365
                  </button> */}

              </form>
           
                
                   {/* <div>
                      <span className="linestyle1">Or Sign Up with
                      </span>
                    </div>
                  <button className="btn2" onClick={handleLogin}>
                  Sign in with Office 365
                  </button>
                */}
           
            </div>
          </div>
          <div className="col-lg-8 col-md-8 col-sm-12 col-two">
            {/* <img
                className="Logo"
                width="100%"
                height="auto"
                src={require("../../images/Isolation_Mode.png")}
                alt="TATA Elxsi"
              ></img> */}
          </div>
        </div>
      </div>
      <div className="backdrop">
        <Backdrop
          sx={{
            color: "var(--themes-color)",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={apiLoad}
          //onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      </UnauthenticatedTemplate>
    </div>
  );
}
export default Userlogin;
